import React from 'react'

const LogoIcon = ({ style, className, width = 156, height = 64 }) => (
    <img
        src="/images/logo.svg"
        alt="Логотип"
        width={width}
        height={height}
        style={style}
        className={className}
    />
)

export default LogoIcon
